export default "__VITE_ASSET__6d6a0571__"